import { CampaignAPI, LookupAPI } from "generated-api"
import { checkIfSessionIsOrWillExpired } from "user/tools/common"
import { ICampaignSchedule, IScheduleRepository, IWeather, WEATHERS } from "./model"

export const scheduleRPO: IScheduleRepository = {
  getSchedule(campaignId: number): Promise<ICampaignSchedule | null> {
    return new Promise<ICampaignSchedule | null>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        CampaignAPI.getApiCampaignSchedule(campaignId)
          .then(response => resolve(response))
          .catch((error: any) => {
            console.error("Server error while getting campaign schedule", error)
            reject("schedule.get.error.server")
          })
      } catch (ex) {
        console.error("Server error while getting campaign schedule", ex)
        reject("schedule.get.error.unexpected")
      }
    })
  },
  createSchedule(campaignId: number, schedule: ICampaignSchedule): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        CampaignAPI.postApiCampaignSchedule({ ...schedule, campaign_id: campaignId })
          .then(() => resolve())
          .catch((error: any) => {
            console.error("Server error while adding schedule", error)
            reject("schedule.create.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while adding schedule", ex)
        reject("schedule.create.error.unexpected")
      }
    })
  },
  updateSchedule(campaignId: number, schedule: ICampaignSchedule): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        CampaignAPI.putApiCampaignSchedule({ ...schedule, campaign_id: campaignId })
          .then(() => resolve())
          .catch((error: any) => {
            console.error("Server error while updating schedule", error)
            reject("schedule.update.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while updating schedule", ex)
        reject("schedule.update.error.unexpected")
      }
    })
  },
  deleteSchedule(campaignId: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        CampaignAPI.deleteApiCampaignSchedule(campaignId)
          .then(() => resolve())
          .catch((error: any) => {
            console.error("Server error while deleting schedule", error)
            reject("schedule.delete.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while deleting schedule", ex)
        reject("schedule.delete.error.unexpected")
      }
    })
  },
  getAvailableWeathers(): Promise<IWeather[]> {
    return new Promise<IWeather[]>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        LookupAPI.getApiWeatherList()
          .then(response => resolve(response.map(w => ({ id: w.id, weather_id: w.name as WEATHERS }))))
          .catch((error: any) => {
            console.error("Server error while getting available weathers", error)
            reject("weather.get.available.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while getting available weathers", ex)
        reject("weather.get.available.error.unexpected")
      }
    })
  },
  getWeathers(campaignId: number): Promise<IWeather[]> {
    return new Promise<IWeather[]>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        CampaignAPI.getApiCampaignWeatherList(campaignId)
          .then(response => resolve(response as IWeather[]))
          .catch((error: any) => {
            console.error("Server error while getting campaign weathers", error)
            reject("weather.get.error.server")
          })
      } catch (ex) {
        console.error("Server error while getting campaign weathers", ex)
        reject("weather.get.error.unexpected")
      }
    })
  },
  createWeather(campaignId: number, weather: WEATHERS): Promise<IWeather> {
    return new Promise<IWeather>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        CampaignAPI.postApiCampaignWeather({ campaign_id: campaignId, weather_id: weather })
          .then(response => resolve(response as IWeather))
          .catch((error: any) => {
            console.error("Server error while creating campaign weather", error)
            reject("weather.create.error.server")
          })
      } catch (ex) {
        console.error("Server error while creating campaign weather", ex)
        reject("weather.create.error.unexpected")
      }
    })
  },
  deleteWeather(campaignId: number, weatherId: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        CampaignAPI.deleteApiCampaignWeather(campaignId, weatherId)
          .then(() => resolve())
          .catch((error: any) => {
            console.error("Server error while deleting campaign weather", error)
            reject("weather.delete.error.server")
          })
      } catch (ex) {
        console.error("Server error while deleting campaign weather", ex)
        reject("weather.delete.error.unexpected")
      }
    })
  }
}
